import React, { useState } from "react";
import { Button } from "./ui/button";
import { MessageCircle, Phone, Menu, X } from "lucide-react";
import { mockData } from "../mock";
import Logo from "src/assets/Images/GJ SkillBay Labs (Logo Presentation)-01.svg";

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      {/* Trust Bar */}
      <div className="bg-slate-900 text-white py-2 px-4">
        <div className="container mx-auto text-center text-sm">
          <span className="inline-flex items-center gap-4 flex-wrap justify-center">
            <span>🏢 Cyberpark, Kozhikode</span>
            <span className="hidden sm:inline">•</span>
            <span>🧠 Business + AI + Tech + Soft Skills</span>
            <span className="hidden sm:inline">•</span>
            <span>🚀 Live Projects at GJ Global</span>
            <span className="hidden sm:inline">•</span>
            <span>👨‍💻 Industry Mentors</span>
          </span>
        </div>
      </div>

      {/* Main Header */}
      <header className="bg-white shadow-sm border-b sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <div className="flex items-center">
              <a href="#hero-container">
                <img
                  src={Logo}
                  alt="GJ SkillBay Labs Logo"
                  className="h-16 w-40 object-contain"
                  onError={(e) => {
                    e.target.style.display = "none";
                    e.target.nextElementSibling.style.display = "flex";
                  }}
                />
              </a>
              <div className="hidden w-10 h-10 bg-orange-500 rounded-lg items-center justify-center text-white font-bold text-lg">
                GJ
              </div>
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-8">
              <a
                href="#programs"
                className="relative text-gray-600 font-medium transition-colors duration-300 hover:text-black
             after:content-[''] after:absolute after:left-0 after:-bottom-1
             after:h-[2px] after:w-full after:bg-black
             after:scale-x-0 after:origin-left
             after:transition-transform after:duration-300
             hover:after:scale-x-100"
              >
                Programs
              </a>

              <a
                href="#process"
                className="relative text-gray-600 font-medium transition-colors duration-300 hover:text-black
             after:content-[''] after:absolute after:left-0 after:-bottom-1
             after:h-[2px] after:w-full after:bg-black
             after:scale-x-0 after:origin-left
             after:transition-transform after:duration-300
             hover:after:scale-x-100"
              >
                How It Works
              </a>

              <a
                href="#domains"
                className="relative text-gray-600 font-medium transition-colors duration-300 hover:text-black
             after:content-[''] after:absolute after:left-0 after:-bottom-1
             after:h-[2px] after:w-full after:bg-black
             after:scale-x-0 after:origin-left
             after:transition-transform after:duration-300
             hover:after:scale-x-100"
              >
                Domain
              </a>

              <a
                href="#mentors"
                className="relative text-gray-600 font-medium transition-colors duration-300 hover:text-black
             after:content-[''] after:absolute after:left-0 after:-bottom-1
             after:h-[2px] after:w-full after:bg-black
             after:scale-x-0 after:origin-left
             after:transition-transform after:duration-300
             hover:after:scale-x-100"
              >
                Mentors
              </a>
              <a
                href="#social-proof"
                className="relative text-gray-600 font-medium transition-colors duration-300 hover:text-black
             after:content-[''] after:absolute after:left-0 after:-bottom-1
             after:h-[2px] after:w-full after:bg-black
             after:scale-x-0 after:origin-left
             after:transition-transform after:duration-300
             hover:after:scale-x-100"
              >
                Placements
              </a>
            </nav>

            {/* CTA Buttons */}
            <div className="hidden lg:flex items-center space-x-3">
              {/* WhatsApp */}
              <Button
                variant="outline"
                size="sm"
                className="flex items-center gap-2 text-green-600 border-green-200 hover:bg-green-50"
                onClick={() =>
                  window.open(
                    "https://api.whatsapp.com/send?phone=919895223307",
                    "_blank"
                  )
                }
              >
                <MessageCircle size={16} />
                <span className="hidden xl:inline">Chat for Syllabus</span>
              </Button>

              {/* Primary CTA */}
              <Button
                className="bg-slate-600 hover:bg-slate-700 text-white px-6"
                onClick={() =>
                  document
                    .getElementById("hero-form")
                    ?.scrollIntoView({ behavior: "smooth" })
                }
              >
                Get Syllabus
              </Button>
            </div>

            {/* Mobile Menu Button */}
            <Button
              variant="outline"
              size="sm"
              className="lg:hidden"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? <X size={20} /> : <Menu size={20} />}
            </Button>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <div className="lg:hidden mt-4 pb-4 border-t">
              <nav className="flex flex-col space-y-3 mt-4">
                <a
                  href="#program"
                  className="text-gray-700 hover:text-slate-600 transition-colors"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Programs
                </a>
                <a
                  href="#process"
                  className="text-gray-700 hover:text-slate-600 transition-colors"
                  onClick={() => setIsMenuOpen(false)}
                >
                  How It Works
                </a>
                <a
                  href="#domains"
                  className="text-gray-700 hover:text-slate-600 transition-colors"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Domains
                </a>
                <a
                  href="#mentors"
                  className="text-gray-700 hover:text-slate-600 transition-colors"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Mentors
                </a>
                <div className="flex flex-col space-y-2 pt-3">
                  <Button
                    variant="outline"
                    size="sm"
                    className="flex items-center gap-2 text-green-600 border-green-200 hover:bg-green-50 justify-center"
                    onClick={() => {
                      window.open(
                        `https://wa.me/${mockData.contact.whatsapp}`,
                        "_blank"
                      );
                      setIsMenuOpen(false);
                    }}
                  >
                    <MessageCircle size={16} />
                    Chat for Syllabus
                  </Button>
                  <Button
                    className="bg-slate-600 hover:bg-slate-700 text-white"
                    onClick={() => {
                      document
                        .getElementById("hero-form")
                        ?.scrollIntoView({ behavior: "smooth" });
                      setIsMenuOpen(false);
                    }}
                  >
                    Get Syllabus
                  </Button>
                </div>
              </nav>
            </div>
          )}
        </div>
      </header>
    </>
  );
};
